<template>
  <div id="viewer" ref="viewer"></div>
</template>

<script>
import WebViewer from '@pdftron/webviewer';

export default {
  name: 'CompareDocs',
  props: {
    path: String,
    link1: {
      type: String,
    },
    link2: {
      type: String,
    },
  },
  async mounted() {
    const instance = await WebViewer(
      {
        path: this.path,
        fullAPI: true,
        licenseKey: process.env.VUE_APP_PDFTRON_LICENSE_KEY,
      },
      this.$refs.viewer
    );
    const { documentViewer, PDFNet } = instance.Core;

    await PDFNet.initialize();

    const newDoc = await PDFNet.PDFDoc.create();
    await newDoc.lock();

    const doc1 = await PDFNet.PDFDoc.createFromURL(this.link1);
    const doc2 = await PDFNet.PDFDoc.createFromURL(this.link2);
    await newDoc.appendTextDiffDoc(doc1, doc2);

    await newDoc.unlock();

    instance.UI.loadDocument(newDoc);

    // wait until the document has been loaded
    documentViewer.addEventListener('documentLoaded', () => {
      instance.UI.setLayoutMode(instance.UI.LayoutMode.FacingContinuous);
    });
    documentViewer.setFitMode(documentViewer.FitMode.FitWidth);
  },
};
</script>
<style scoped>
div {
  width: 100%;
  height: 100%;
}
</style>
